import { render, staticRenderFns } from "./InventoryMaterialVariant.vue?vue&type=template&id=e0834004&scoped=true"
import script from "./InventoryMaterialVariant.vue?vue&type=script&lang=js"
export * from "./InventoryMaterialVariant.vue?vue&type=script&lang=js"
import style0 from "./InventoryMaterialVariant.vue?vue&type=style&index=0&id=e0834004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0834004",
  null
  
)

export default component.exports